import * as React from "react";
import { cn } from "~/lib/utils";

type BottomSheetHeaderProps = React.HTMLAttributes<HTMLDivElement>;

export function BottomSheetHeader({ className, ...props }: BottomSheetHeaderProps) {
  return (
    <div
      data-slot="bottom-sheet-header"
      className={cn("sticky top-0 z-10 bg-card px-4 py-4 rounded-t-xl", className)}
      {...props}
    />
  );
}
